<template>
  <section class="ticket--admin--body">
    <b-tabs>
      <b-tab>
        <template #title><div><feather-icon icon="SettingsIcon"/> Gestión</div></template>
        <management-tab :masterData="masterData" :ticket="ticket" @updateTicket="updateTicket"></management-tab>
      </b-tab>
      <b-tab disabled>
        <template #title>
          <div><feather-icon icon="ClockIcon"/> Historial <b-badge variant="info">Próximamente</b-badge></div>
        </template>
      </b-tab>
      <b-tab disabled>
        <template #title>
          <div><feather-icon icon="FileTextIcon"/> Detalle envío <b-badge variant="info">Próximamente</b-badge></div>
        </template>
      </b-tab>
      <template #tabs-end v-if="showAssignment">
        <div class="tab--end">
          <b-badge variant="outline-primary" class="d-flex align-items-center">
            <icons class="mr-05" :icon="'TicketIcon'"></icons>
            {{ticket.assignment.user_assignment}}
          </b-badge>
        </div>
      </template>
    </b-tabs>
  </section>
</template>
<script>
import ManagementTab from '@/views/modules/tickets/components/Detail/Body/Tabs/MaganementTab.vue'
import Icons from '@/Icons/Icons.vue'
export default {
  props: ['ticket', 'masterData'],
  components: { ManagementTab, Icons },
  methods: {
    updateTicket() {
      this.$emit('updateTicket', true)
    }
  },
  computed: {
    showAssignment() {
      return !!this.ticket?.assignment?.user_assignment
    }
  }
}
</script>
<style lang="scss">
  .ticket--admin--body {
    .tab--end {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      align-items: end;
      padding-right: 50px;

      .badge svg {
        width: 18px;
        height: 18px;
        stroke-width: 1px;
      }
      .badge.badge-outline-primary {
        background: #e1e8f1;
      }
    }
  }
</style>